var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"src":_vm.src,"width":"100%","id":"myiframe"}})
}
var staticRenderFns = []

export { render, staticRenderFns }